import gql from "graphql-tag";

export const QueryGetAssessment = gql(`
query getAssessment($therapistId: ID! $assessmentId: String!) {
    getAssessment(therapistId: $therapistId assessmentId: $assessmentId) {
        assessmentId
        firstName
        lastName
        birthday
        medicalNumber
    }
}`);

export const MutationCreateAssessment = gql(`
mutation(
    $therapistId: ID!
    $assessmentId: String!
    $createdBy: String
    $firstName: String!
    $lastName: String!
    $birthday: String
    $medicalNumber: String
    $searchField: String
    $created: String
    $updated: String
) {
    createAssessment(input: {
        therapistId: $therapistId
        assessmentId: $assessmentId
        createdBy: $createdBy
        firstName: $firstName
        lastName: $lastName
        birthday: $birthday
        medicalNumber: $medicalNumber
        searchField: $searchField
        created: $created
        updated: $updated
    }) {
        assessmentId
        firstName
        lastName
    }
}`);

export const MutationUpdateAssessment = gql(`
mutation(
    $therapistId: ID!
    $assessmentId: String!
    $firstName: String!
    $lastName: String!
    $birthday: String
    $medicalNumber: String
    $searchField: String
    $created: String
    $updated: String
) {
    updateAssessment(input: {
        therapistId: $therapistId
        assessmentId: $assessmentId
        firstName: $firstName
        lastName: $lastName
        birthday: $birthday
        medicalNumber: $medicalNumber
        searchField: $searchField
        created: $created
        updated: $updated
    }) {
        firstName
        lastName
        medicalNumber
    }
}`);

export const QueryAssessmentsList = gql(`
query(
    $id: ID!
    $limit: Int
    $nextToken: String
) {
    getTherapist(id: $id) {
        assessments(
            limit: $limit
            nextToken: $nextToken
        ) {
            nextToken,
            items {
                assessmentId
                firstName
                lastName
                birthday
                medicalNumber
                created
            }
        }
    }
}`);

export const QueryCheckMedicalNumber = gql(`
query(
    $therapistId: ID!
    $medicalNumber: String
) {
    checkMedicalNumber(
        therapistId: $therapistId
        medicalNumber: $medicalNumber
    ) {
        items {
            therapistId
            assessmentId
        }
    }
}`);

export const QueryAssessmentsIdsList = gql(`
query($id: ID!) {
    getTherapist(id: $id) {
        assessments {
            items {
                assessmentId
            }
        }
    }
}`);

export const QueryGetFilterPatient = gql(`
query(
    $therapistId: ID!
    $keyword: String
    $limit: Int
    $nextToken: String
) {
    getFilterPatient(
        therapistId: $therapistId
        keyword: $keyword
        limit: $limit
        nextToken: $nextToken
    ) {
        nextToken
        items {
            therapistId
            assessmentId
            firstName
            lastName
            birthday
            medicalNumber
            created
        }
    }
}`);

export const MutationDeleteAssessment = gql(`
mutation(
    $therapistId: ID!
    $assessmentId: String!
) {
    deleteAssessment(input: {
        therapistId: $therapistId
        assessmentId: $assessmentId
    }) {
        __typename
    }
}`);

export const MutationDeleteAssessmentAndAnalysis = gql(`
mutation(
    $therapistId: ID!
    $assessmentId: String!
    $analysisIds: [String!]
) {
    deleteAssessmentAndAnalysis(input: {
        therapistId: $therapistId
        assessmentId: $assessmentId
        analysisIds: $analysisIds
    }) {
        __typename
    }
}`);

export const QueryGetAnalysisIds = gql(`
query getAssessment($therapistId: ID! $assessmentId: String!) {
    getAssessment(therapistId: $therapistId assessmentId: $assessmentId) {
        analysis {
          items {
            __typename
            analysisId
          }
        }
    }
}`);
